import { z } from 'zod';
import { BaseErrorSchema } from '../../../../shared/error.schema';
/**
 * Resend SuperAdmin Invitation Request Schema
 * POST /api/v2/superadmin-users/:userId/resend-invitation
 * Resends the invitation email to a pending superadmin user
 */ export const ResendSuperAdminInvitationRequestSchema = z.object({
    userId: z.string()
});
/**
 * Resend SuperAdmin Invitation Response Schema
 * Returned on successful invitation resend
 */ export const ResendSuperAdminInvitationResponseSchema = z.object({
    success: z.boolean(),
    message: z.string()
});
/**
 * Resend SuperAdmin Invitation Error Schema
 * Returned when invitation resend fails
 */ export const ResendSuperAdminInvitationErrorSchema = BaseErrorSchema;

//# sourceMappingURL=resend-superadmin-invitation.schema.js.map